import { render } from "./GroupPhoto.vue?vue&type=template&id=5354eca2&scoped=true"
import script from "./GroupPhoto.vue?vue&type=script&lang=js"
export * from "./GroupPhoto.vue?vue&type=script&lang=js"

import "./GroupPhoto.vue?vue&type=style&index=0&id=5354eca2&scoped=true&lang=css"

import exportComponent from "/home/rosenfeldt/projects/rosenfeldt/public_html/webshop/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5354eca2"]])

export default __exports__